var amountCounter = 2;
var authorityCounter = 2;
var counter = 2;
var counter_c = 2;

window.addOption = function (form, name, placeholder, div_text_id, field) {
  if (counter > 5) {
    alert("Se permiten solo 5 opciones");
    return false;
  }

  var newDiv = $(document.createElement("div")).attr("id", field + counter);
  newDiv
    .after()
    .html(
      `<input type="text" form="${form}" name="${name}" class="form-input" placeholder="${placeholder}"><br/>`
    );
  newDiv.appendTo(div_text_id);
  counter++;
};

window.removeOption = function (field) {
  if (counter == 2) {
    alert("No se puede eliminar mas");
    return false;
  }
  counter--;
  $("#" + field + counter).remove();
};

window.addOption_edit = function (form, name, placeholder, div_text_id, field) {
  var divs = document.getElementsByClassName("amount").length;
  if (divs > 5) {
    alert("Se permiten solo 5 opciones");
    return false;
  }
  var a_id = "a#" + divs.toString();

  var newDiv = $(document.createElement("div")).attr(
    "id",
    field + divs.toString()
  );
  newDiv.attr("class", "amount");
  newDiv.after().html(
    `<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
      <input type="text" form="${form}" name="${name}" class="form-input" placeholder="${placeholder}">
      <a class="plus-and-minus" onclick="window.addOption_edit('create_room','amount[]', 'Opción de disposición y cantidad', '#amount-people', 'amount')"><i class="fa fa-plus-circle"></i></a>

      <a id='${a_id}' class="plus-and-minus" onclick="window.removeOption_edit('amount',${divs})"><i class="fa fa-minus-circle"></i></a> <br/> `
  );
  newDiv.appendTo(div_text_id);
  counter++;
};

window.removeOption_edit = function (field, id_element) {
  console.log(id_element);
  var divs = document.getElementsByClassName("amount").length;
  if (divs <= 1) {
    alert("No se puede eliminar mas");
    return false;
  }
  console.log(field, id_element);
  $("#" + field + id_element).remove();
};

window.disableParams = function (value) {
  if (value.value == "Auditorio") {
    $("#uc_price_h").prop("disabled", true);
    $("#ex_price_h").prop("disabled", true);
    $("#cdi_price_h").prop("disabled", true);
    $("#uc_price_h").attr("placeholder", "No disponible");
    $("#ex_price_h").attr("placeholder", "No disponible");
    $("#cdi_price_h").attr("placeholder", "No disponible");
    // $("input").prop('disabled', false);
  } else {
    $("#uc_price_h").prop("disabled", false);
    $("#ex_price_h").prop("disabled", false);
    $("#cdi_price_h").prop("disabled", false);
    $("#uc_price_h").attr("placeholder", "");
    $("#ex_price_h").attr("placeholder", "");
    $("#cdi_price_h").attr("placeholder", "");
  }
};

window.add_coffe = function (form, div_text_id, field) {
  if (counter_c > 5) {
    alert("Se permiten solo 5 opciones");
    return false;
  }
  var service = $("#coffee_selector option:selected").text(),
    amount = $("#amount-coffe").val(),
    coffe_id = $("#coffee_selector").val();
  price = parseInt($("#coffe-price").text().replace("$", ""));
  var newDiv = $(document.createElement("div")).attr("id", field + counter_c);
  newDiv.addClass("card half text-center");
  newDiv.after().html(
    `<label class="form-label">Nombre del servicio</label>
      <input class="label-coff " type="text" form="${form}" id='${
      field + counter_c + "service"
    }' value="${service}" readonly>
      <input form="${form}" name="coffe[coffe_id][]" value="${coffe_id}" hidden>
      <label class="form-label">Cantidad de personas</label>
      <input class="label-coff "  type="number" form="${form}" id='${
      field + counter_c + "amount"
    }' name="coffe[amount_coffe][]"  value="${amount}" readonly>
      <label class="form-label">Valor Unitario Servicio</label>
      <input class="label-coff" type="number" id='${
        field + counter_c + "price"
      }' value="${price}" readonly><p>$CLP   </p>`
  );
  newDiv.appendTo(div_text_id);
  counter_c++;
};

window.remove_coffe = function (field) {
  if (counter_c == 2) {
    alert("No se puede eliminar mas");
    return false;
  }
  counter_c--;
  var price =
    $("#" + field + counter_c + "price").val() *
    $("#" + field + counter_c + "amount").val();
  var final_price = parseInt($("#final-price-coffe").text().replace("$", ""));
  var newfinal = final_price - price;
  $("#final-price-coffe").text("$" + newfinal);
  $("#" + field + counter_c).remove();
};

window.reservation_repeat = function (tonggle) {
  if ($(tonggle).is(":checked")) {
    $("#block-repeat").val($("#hour_selector").val());
    $("#start-repeat").val($("#datepicker").val());
    var date = new Date($("#datepicker").val().replace(/-/g, "/"));
    $("#day-repeat").val(date.getDay());
    $("#repeat-reservation-div").css("display", "block");
  } else {
    $("#repeat-reservation-div").css("display", "none");
  }
};

window.update_repeat = function () {
  $("#block-repeat").val($("#hour_selector").val());
  var date = new Date($("#datepicker").val().replace(/-/g, "/"));
  $("#start-repeat").val($("#datepicker").val());
  $("#day-repeat").val(date.getDay());
};
